import { render, staticRenderFns } from "./OrdersListFiltersForm.vue?vue&type=template&id=09255cfb&scoped=true&"
import script from "./OrdersListFiltersForm.vue?vue&type=script&lang=js&"
export * from "./OrdersListFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListFiltersForm.vue?vue&type=style&index=0&id=09255cfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09255cfb",
  null
  
)

export default component.exports